import { useSelector } from 'react-redux';
import { User } from 'new/entities/User';
import { getUserEntities } from 'js/reducers/selectors';

type UseUserRepository = {
  users: Record<number, User>;
  getUserById(id: number): User | undefined;
};

function useUserRepository(): UseUserRepository {
  const users = useSelector(getUserEntities);

  function getUserById(id: number) {
    return users?.[id];
  }

  return {
    users,
    getUserById,
  };
}

export { useUserRepository };
